import { createRouter, createWebHistory } from "vue-router";
import store from "./store";

// All page components are now lazy-loaded via dynamic import().
// Each becomes its own chunk, downloaded only when that route is visited —
// this is the fix for the 447KB app.js bundle from your build output.
// Nothing here needs to change again as you add routes; just keep using
// the () => import('...') pattern for anything new.
//
// Every route also carries meta.guideKey, matching a key in
// src/components/pagesGuide.js. FirstVisitGuide.vue and OnboardingTour.vue
// both look pages up by that key, so add one whenever you add a route —
// see pagesGuide.js for the format.

const LoginUser = () => import("./components/pages/LoginUser.vue");
const getTenantStatement = () => import("./components/pages/getTenantStatement.vue");
const registerUser = () => import("./components/pages/registerUser.vue");
const HomePage = () => import("./components/pages/HomePage.vue");
const DashBoard = () => import("./components/pages/DashBoard");
const AddUnit = () => import("./components/pages/AddUnit.vue");
const allUnits = () => import("./components/pages/UnitsList.vue");
const newHouse = () => import("./components/pages/newHouse.vue");
const AddTenant = () => import("./components/pages/addTenant.vue");
const TenantsList = () => import("./components/pages/TenantsList.vue");
const HousesList = () => import("./components/pages/HousesList.vue");
const UnitsList = () => import("./components/pages/UnitsList.vue");
const AssignTenant = () => import("./components/pages/AssignTenant.vue");
const uploadUnits = () => import("./components/pages/uploadUnits.vue");
const testTemplate = () => import("./components/pages/testTemplate.vue");
const editTenant = () => import("./components/pages/editTenant.vue");
const AddBilling = () => import("./components/pages/addBilling.vue");
const Addwaterreadings = () => import("./components/pages/waterReadings.vue");
const Addelectricityreadings = () => import("./components/pages/electricityReadings.vue");
const getBills = () => import("./components/pages/getBills.vue");
const uploadUnitwithTenants = () => import("./components/pages/uploadunitswithtenants.vue");
const TenantDetails = () => import("./components/pages/tenantDetails.vue");
const MonthlyBillings = () => import("./components/pages/monthlyBillings.vue");
const Invoices = () => import("./components/pages/Invoices.vue");
const InvoiceDetails = () => import("./components/pages/invoiceDetails.vue");
const ReceivePayments = () => import("./components/pages/receivePayments.vue");
const Payments = () => import("./components/pages/Payments.vue");
const CreatePaybill = () => import("./components/pages/createPaybill.vue");
const updateProfile = () => import("./components/pages/updateprofile.vue");
const Profile = () => import("./components/pages/profile.vue");
const VerifyAccount = () => import("./components/pages/verifyAccount.vue");
const TenantsSms = () => import("./components/pages/tenantsSms.vue");
const SmsHistory = () => import("./components/pages/smsHistory.vue");
const passwordReset = () => import("./components/pages/passwordreset.vue");
const forgotPassword = () => import("./components/pages/forgotPassword.vue");
const SendOtp = () => import("./components/pages/SendOtp.vue");
const FaqPage = () => import("./components/pages/FaqPage.vue")
// New: the demo-request landing page CTA links point to
const BookDemo = () => import("./components/pages/bookDemo.vue");

// TODO: these two are referenced by your footer/mobile nav (per the console
// warnings) but no matching component exists yet in this router. Point them
// at real page files once you have Privacy/Terms content, or a lightweight
// "Coming soon" page in the meantime — don't leave the links broken.
// const PrivacyPolicy = () => import("./components/pages/PrivacyPolicy.vue");
// const TermsOfService = () => import("./components/pages/TermsOfService.vue");

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: HomePage, meta: { guideKey: "HomePage" } },
    { path: "/add/unit", component: AddUnit, meta: { auth: true, guideKey: "AddUnit" } },
    { path: "/upload/units", component: uploadUnits, meta: { auth: true, guideKey: "uploadUnits" } },
    { path: "/get/bills", component: getBills, meta: { auth: true, guideKey: "getBills" } },
    { path: "/update/profile", component: updateProfile, meta: { auth: true, guideKey: "updateprofile" } },
    { path: "/profile", component: Profile, meta: { auth: true, guideKey: "profile" } },
    { path: "/verify-account", component: VerifyAccount, meta: { auth: false, guideKey: "verifyAccount" } },
    { path: "/tenants/sms", component: TenantsSms, meta: { auth: true, guideKey: "tenantsSms" } },
    { path: "/sms/history", component: SmsHistory, meta: { auth: true, guideKey: "smsHistory" } },
    { path: "/reset/password", component: passwordReset, meta: { auth: false, guideKey: "passwordreset" } },
    { path: "/forgot-password", component: forgotPassword, meta: { auth: false, guideKey: "forgotPassword" } },

    { path: "/book-demo", component: BookDemo, meta: { auth: false, guideKey: "bookDemo" } },
    { path: "/help", component: FaqPage, meta: { auth: false, guideKey: "Help" } },
    // { path: "/privacy", component: PrivacyPolicy, meta: { auth: false } },
    // { path: "/terms", component: TermsOfService, meta: { auth: false } },

    { path: "/add-units", component: AddUnit, meta: { auth: false, guideKey: "AddUnit" } },

    { path: "/upload/unitswithtenants", component: uploadUnitwithTenants, meta: { auth: true, guideKey: "uploadunitswithtenants" } },

    { path: "/add/tenant", component: AddTenant, meta: { auth: true, guideKey: "addTenant" } },
    { path: "/add/house", component: newHouse, meta: { auth: true, guideKey: "newHouse" } },
    { path: "/receive/payments", component: ReceivePayments, meta: { auth: true, guideKey: "receivePayments" } },
    { path: "/create/paybill", component: CreatePaybill, meta: { auth: true, guideKey: "createPaybill" } },

    { path: "/sendOtp/", component: SendOtp, meta: { auth: true, guideKey: "SendOtp" } },
    { path: "/tenant/:tenant_id/statement", name: "TenantStatement", component: getTenantStatement, meta: { requiresAuth: true, guideKey: "getTenantStatement" } },

    { path: "/tenants", component: TenantsList, meta: { auth: true, guideKey: "TenantsList" } },
    { path: "/edit-tenant/:tenant_id", component: editTenant, meta: { auth: true, guideKey: "editTenant" } },
    { path: "/houses", component: HousesList, meta: { auth: true, guideKey: "HousesList" } },
    { path: "/all/units", component: allUnits, meta: { auth: true, guideKey: "UnitsList" } },
    { path: "/all/payments", component: Payments, meta: { auth: true, guideKey: "Payments" } },

    { path: "/house/:houseId/units", component: UnitsList, meta: { auth: true, guideKey: "UnitsList" } },
    { path: "/assign/tenant/:unitId", component: AssignTenant, meta: { auth: true, guideKey: "AssignTenant" } },
    { path: "/house/:house_Id/water-readings", component: Addwaterreadings, meta: { auth: true, guideKey: "waterReadings" } },
    { path: "/house/:house_Id/electricity-readings", component: Addelectricityreadings, meta: { auth: true, guideKey: "electricityReadings" } },

    { path: "/tenant/:tenant_id", component: TenantDetails, meta: { auth: true, guideKey: "tenantDetails" } },

    { path: "/ronnie/test/", component: testTemplate },
    { path: "/add/bill/", component: AddBilling, meta: { auth: true, guideKey: "addBilling" } },
    { path: "/monthly/billings/", component: MonthlyBillings, meta: { auth: true, guideKey: "monthlyBillings" } },
    { path: "/invoices/", component: Invoices, meta: { auth: true, guideKey: "Invoices" } },
    { path: "/invoice/:invoice_id", component: InvoiceDetails, meta: { auth: true, guideKey: "invoiceDetails" } },

    { path: "/login", component: LoginUser, meta: { auth: false, guideKey: "LoginUser" } },
    { path: "/register", component: registerUser, meta: { auth: false, guideKey: "registerUser" } },


    { path: "/dashboard", component: DashBoard, meta: { auth: true, guideKey: "DashBoard" } },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.auth)) {
    if (!store.getters.isLoggedIn) {
      next({ path: "/login" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
